// extracted by mini-css-extract-plugin
export default {"spinner":"voucher-detail_spinner__1iVbI"};